'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the best Koli Matrimony in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com is the best Koli Matrimony in Maharashtra.' },
  { question: 'Which is the best Mahadev Koli Matrimony for Marathi?', answer: 'MarathiVadhuVarSuchak.com is the best Mahadev Koli Matrimony for Marathi Vadhu Var.' },
  { question: 'Which is the best Agri Koli Matrimony?', answer: "'Marathi Vadhu Var Suchak' is the most trusted Agri Koli Matrimony in Maharashtra state." },
  { question: 'How to join Koli Matrimony WhatsApp Group Link?', answer: "No! 'Marathi Vadhu Var Suchak' does not have any WhatsApp group due to privacy policy." },
  { question: 'How to do Koli Matrimony login online?', answer: 'Marathi Koli Vadhu Var can visit MarathiVadhuVarSuchak.com for free registration. After profile approval you can login for profile search.' },
  { question: 'Which is the best Hindu Mahadev Koli Matrimony in Mumbai?', answer: 'Marathi Matrimony MarathiVadhuVarSuchak.com is the best Hindu Mahadev Koli Matrimony in Mumbai.' },
  { question: 'Which are the trusted Koli Matrimony sites for Marathi?', answer: 'From multiple options, MarathiVadhuVarSuchak.com is the most trusted Koli Matrimony site for Marathi Vadhu Var.' },
  { question: 'How to search Koli Matrimony brides online?', answer: 'To search Koli Matrimony brides online, visit MarathiVadhuVarSuchak.com Matrimonial site for free registration.' },
  { question: 'Which is the trusted Koli Matrimony Marathi?', answer: 'For Marathi Vadhu Var, MarathiVadhuVarSuchak.com is the most trusted Koli Matrimony for Marathi Vadhu Var.' },
  { question: 'How to join Hindu Mahadev Koli Matrimony Nashik?', answer: 'For Nashik based Mahadev Koli Vadhu Var, MarathiVadhuVarSuchak.com matrimony is the best option to register free.' },
  { question: 'Which is the best Mahadev Koli Vadhu Var Suchak in Pune?', answer: 'For Pune based Mahadev Koli Vadhu Var, MarathiVadhuVarSuchak.com is the most trusted brand.' },
  { question: 'How to join Koli Vadhu Var WhatsApp group?', answer: "No! 'Marathi Vadhu Var Suchak' does not have any WhatsApp group to join free." },
  { question: 'Which is the best Mahadev Koli Vadhu Var Suchak Nashik?', answer: 'MarathiVadhuVarSuchak.com is the trusted Mahadev Koli Vadhu Var Suchak for Nashik based Vadhu Var.' },
  { question: 'Which is the trusted Koli Vadhu Var Suchak Kendra Mumbai?', answer: 'MarathiVadhuVarSuchak.com matrimonial is the trusted Koli Vadhu Var Suchak Kendra for Mumbai based Vadhu Var.' },
  { question: 'How to search Koli Vadhu Var Suchak Mandal?', answer: 'Visit MarathiVadhuVarSuchak.com to register free. After approval Mahadev Koli Vadhu Var search Koli Caste profiles.' },
  { question: 'Which is the best Mahadev Koli Vadhu Var Suchak Kendra?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimony is the best Mahadev Koli Vadhu Var Suchak Kendra for Marathi.' },
  { question: 'Which is the trusted Hindu Mahadev Koli Vadhu Var Suchak Mandal?', answer: 'For Hindu Mahadev Koli Vadhu Var from Maharashtra, MarathiVadhuVarSuchak.com is the trusted brand.' },
  { question: 'Which is the best Aagri Koli Vadhu Var in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com is the trusted Aagri Koli Vadhu Var in Maharashtra.' },
  { question: 'Which is the best Mahadev Koli Vadhu Var Suchak Kendra Pune?', answer: 'For Pune based Mahadev Koli Vadhu Var, MarathiVadhuVarSuchak.com matrimony is the most trusted brand.' },
  { question: 'Which is the trusted Koli Vadhu Var Suchak Mandal in Thane?', answer: 'MarathiVadhuVarSuchak.com is the trusted Koli Vadhu Var Suchak Mandal in Thane region.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Koli caste" },
  { label: "Koli caste category" },
  { label: "Koli caste in which category" },
  { label: "Hindu Mahadev Koli caste category" },
  { label: "Koli caste category in Maharashtra" },
  { label: "Hindu Koli caste category" },
  { label: "Mahadev Koli caste" },
  { label: "Mahadev Koli caste category" },
  { label: "Hindu Koli caste category in Maharashtra" },
  { label: "Koli caste in Maharashtra" },
  { label: "Hindu Mahadev Koli caste category in Marathi" },
  { label: "Mahadev Koli caste category in Marathi" },
  { label: "Mahadev Koli caste category in Maharashtra" },
  { label: "Mahadev Koli tribe" },
  { label: "Mahadev Koli category" },
  { label: "Mahadev Koli matrimony" },
  { label: "Mahadev Koli tribe in Maharashtra" },
  { label: "Mahadev Koli brides" },
  { label: "Koli Matrimony" },
  { label: "Agri Koli Matrimony" },
  { label: "Koli Matrimony WhatsApp group link" },
  { label: "Koli Matrimony login" },
  { label: "Hindu Mahadev Koli matrimony" },
  { label: "Koli Matrimony sites" },
  { label: "Koli Matrimony brides" },
  { label: "Koli Matrimony Marathi" },
  { label: "Hindu Mahadev Koli Matrimony Nashik" },
  { label: "Koli Vadhu Var WhatsApp group" },
  { label: "Mahadev Koli Vadhu Var Suchak" },
  { label: "Mahadev Koli Vadhu Var Suchak Nashik" },
  { label: "Koli Vadhu Var Suchak Kendra Mumbai" },
  { label: "Koli Vadhu Var Suchak" },
  { label: "Koli Vadhu Var Suchak Mandal" },
  { label: "Mahadev Koli Vadhu Var Suchak Kendra" },
  { label: "Koli Vadhu Var WhatsApp group link" },
  { label: "Hindu Mahadev Koli Vadhu Var Suchak Mandal" },
  { label: "Aagri Koli Vadhu Var" },
  { label: "Mahadev Koli Vadhu Var Suchak Kendra Pune" },
  { label: "Koli Vadhu Var Suchak Mandal in Thane" },
];

export default function MahadevKoliMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी कोळी समाज वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="mahadev_koli_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Mahadev Koli Matrimony for Marathi Mahadev Koli Communities"
        items={communityServices}
      />

    </div>
  );
}
